/**
 * Generate auto-parameters for event
 * @param {HTMLElement} element - Clicked element
 * @param {Object} eventDef - Event definition from backend
 * @returns {Object} - Auto-generated event parameters
 */
export function generateEventParams(element, eventDef) {
  const params = {
    // Element identification
    selector: eventDef.selector,
    element_type: element.tagName,

    // Element content
    text: element.textContent.trim(),

    // Page context
    url: window.location.href,
    page_path: window.location.pathname,
    page_title: document.title,

    // Event metadata
    event_category: 'EventFoundry',
    event_label: eventDef.eventLabel
  };

  // Optional attributes (only if present)
  if (element.id) {
    params.element_id = element.id;
  }

  if (element.className) {
    params.element_classes = element.className;
  }

  if (element.href) {
    params.href = element.href;
  }

  return params;
}
